import { Component, Input } from "@angular/core";
import { SplitBarSegment, SplitBarTone } from "../card-types";

@Component({
  selector: "split-bar",
  templateUrl: "./split-bar.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class SplitBarComponent {
  @Input() fillPercentage: number = 0;
  @Input() fillTone: SplitBarTone;
  @Input() segments: SplitBarSegment[] = [];
  @Input() isReport: boolean = false;

  trackByIndex(index: number): number {
    return index;
  }
}
